import { useState, useEffect } from 'react';
import { Modal, Button } from '@components/ui';
import { uygulamaDurumlari } from '@mocks/materials/izolasyon';

export default function UygulamaModal({ isOpen, onClose, onSubmit, data, isLoading = false }) {
    const [uygulamaYuzde, setUygulamaYuzde] = useState(0);
    const [kalanMiktar, setKalanMiktar] = useState(0);
    const [uygulamaDurumu, setUygulamaDurumu] = useState('');
    const [not, setNot] = useState('');

    useEffect(() => {
        if (data) {
            setUygulamaYuzde(data.uygulamaYuzde || 0);
            setKalanMiktar(data.kalanMiktar || 0);
            setUygulamaDurumu(data.uygulamaDurumu || 'bekliyor');
        }
    }, [data]);

    const handleYuzdeChange = (value) => {
        const yuzde = Math.min(100, Math.max(0, parseInt(value) || 0));
        setUygulamaYuzde(yuzde);
        setKalanMiktar(Math.max(0, (data?.miktar || 0) * (1 - yuzde / 100)));
        // Otomatik durum güncelle
        if (yuzde >= 100) setUygulamaDurumu('tamamlandi');
        else if (yuzde > 0) setUygulamaDurumu('devam');
    };

    const handleSubmit = () => {
        onSubmit({ uygulamaYuzde, kalanMiktar, uygulamaDurumu, not });
    };

    if (!data) return null;
    const inputClass = "w-full px-3 py-2.5 bg-bg-primary border border-border-light rounded-lg text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-primary/50";

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Uygulama Güncelle" size="sm"
            footer={<><Button variant="ghost" onClick={onClose} disabled={isLoading}>İptal</Button><Button variant="success" onClick={handleSubmit} isLoading={isLoading}>Güncelle</Button></>}>
            <div className="space-y-4">
                <div className="p-3 bg-bg-tertiary rounded-lg">
                    <div className="flex items-center gap-2 mb-1">
                        <span className="px-2 py-0.5 bg-success/10 text-success rounded text-xs font-medium">{data.tip}</span>
                    </div>
                    <p className="font-medium text-text-primary">{data.marka} - {data.model}</p>
                    <p className="text-sm text-text-secondary">Toplam: {data.miktar} {data.birim}</p>
                </div>

                <div>
                    <label className="block text-sm font-medium text-text-primary mb-1.5">Uygulama (%)</label>
                    <input type="range" min={0} max={100} value={uygulamaYuzde} onChange={(e) => handleYuzdeChange(e.target.value)}
                        className="w-full h-2 bg-bg-tertiary rounded-lg appearance-none cursor-pointer accent-success" />
                    <div className="flex justify-between mt-1">
                        <input type="number" min={0} max={100} value={uygulamaYuzde} onChange={(e) => handleYuzdeChange(e.target.value)}
                            className="w-20 px-2 py-1 bg-bg-primary border border-border-light rounded text-sm text-center" />
                        <span className={`text-sm font-medium ${uygulamaYuzde >= 100 ? 'text-success' : 'text-warning'}`}>%{uygulamaYuzde}</span>
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-medium text-text-primary mb-1.5">Kalan Stok ({data.birim})</label>
                    <input type="number" step="0.1" value={kalanMiktar.toFixed(1)} readOnly className={`${inputClass} bg-bg-tertiary`} />
                </div>

                <div>
                    <label className="block text-sm font-medium text-text-primary mb-1.5">Durum</label>
                    <select value={uygulamaDurumu} onChange={(e) => setUygulamaDurumu(e.target.value)} className={inputClass}>
                        {uygulamaDurumlari.map(u => <option key={u.key} value={u.key}>{u.label}</option>)}
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-medium text-text-primary mb-1.5">Not</label>
                    <input type="text" value={not} onChange={(e) => setNot(e.target.value)} placeholder="Uygulama notu..." className={inputClass} />
                </div>
            </div>
        </Modal>
    );
}
